import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import TabMenu from 'js/components/Navigation/TabMenu'
import TabPanel from 'js/components/Navigation/TabPanel'

import Invite from './components/Invite'
import Invited from './components/Invited'

type Props = {
    guid: string
}

const InvitePeople = ({ guid }: Props) => {
    const { t } = useTranslation()

    const [tab, setTab] = useState('invite')
    const tabOptions = [
        {
            label: t('action.invite'),
            onClick: () => setTab('invite'),
            isActive: tab === 'invite',
            id: 'tab-invite',
            ariaControls: 'panel-invite',
        },
        {
            label: t('global.invited'),
            onClick: () => setTab('invited'),
            isActive: tab === 'invited',
            id: 'tab-invited',
            ariaControls: 'panel-invited',
        },
    ]

    return (
        <>
            <TabMenu
                label={t('action.invite')}
                options={tabOptions}
                showBorder
                edgePadding
                edgeMargin
            />

            <TabPanel
                id={`panel-${tab}`}
                aria-labelledby={`tab-${tab}`}
                visible
                style={{
                    /* Enables scrollbar in modal content */
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                }}
            >
                {tab === 'invite' && (
                    <Invite guid={guid} onComplete={() => setTab('invited')} />
                )}
                {tab === 'invited' && <Invited guid={guid} />}
            </TabPanel>
        </>
    )
}

export default InvitePeople
